/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'shield': {
    width: 16,
    height: 16,
    viewBox: '0 0 16.75 17.76',
    data: '<g data-name="图层 2"><g data-name="图层 1"><path pid="0" d="M8.37 17.76a.5.5 0 01-.27-.08A17.74 17.74 0 010 2.77a.5.5 0 01.36-.48L8.23 0a.5.5 0 01.28 0l7.88 2.29a.5.5 0 01.36.48 17.74 17.74 0 01-8.1 14.91.5.5 0 01-.28.08zM1 3.15a16.74 16.74 0 007.37 13.51 16.74 16.74 0 007.42-13.51L8.37 1z" _fill="#c4c4c4"/><circle pid="1" cx="8.37" cy="7.88" r="3.63" _fill="#74777a"/></g></g>'
  }
})
